module.exports = __webpack_public_path__ + "img/nature-6.3469c646.jpg";